// Facebook Pixel helper functions
const FACEBOOK_PIXEL_ID = '24819162744383006';

// Check if Facebook Pixel is loaded
const checkFBPresence = () => typeof window.fbq === 'function';

// Initialize Facebook Pixel (if not already initialized)
export const initFacebookPixel = (pixelId = FACEBOOK_PIXEL_ID) => {
  if (typeof window.fbq !== 'function') {
    console.warn('Facebook Pixel not loaded');
    return false;
  }
  if (!window.__fbPixelInitialized) {
    window.fbq('init', pixelId);
    window.__fbPixelInitialized = true;
  }
};

// Track page view
export const trackPageView = (page) =>
  checkFBPresence() &&
  window.fbq('track', 'PageView', {
    ...page,
  });

// Track custom events (non-standard events)
export const trackCustomEvent = (eventName, parameters) =>
  checkFBPresence() &&
  window.fbq('trackCustom', eventName, {
    ...parameters,
  });

// Track standard events (deprecated: use specific event functions)
export const trackEvent = (eventName, parameters) =>
  checkFBPresence() &&
  window.fbq('track', eventName, {
    ...parameters,
  });

// Track signup event
export const trackSignup = (method = 'email') =>
  checkFBPresence() &&
  window.fbq('track', 'CompleteRegistration', {
    content_name: 'User Registration',
    content_category: 'User Signup',
    value: 0,
    currency: 'EUR',
    method: method,
  });

// Track login event (custom event - not a standard Meta event)
export const trackLogin = (method = 'email') =>
  checkFBPresence() &&
  window.fbq('trackCustom', 'Login', {
    content_name: 'User Login',
    content_category: 'User Authentication',
    method: method,
  });

// Track subscription/purchase event
export const trackSubscription = (subscriptionData) => {
  const { plan, amount, currency = 'EUR', period } = subscriptionData;

  return (
    checkFBPresence() &&
    window.fbq('track', 'Purchase', {
      content_name: plan,
      content_category: 'Subscription',
      value: parseFloat(amount),
      currency: currency,
      content_type: 'subscription',
      period: period,
    })
  );
};

// Track lead event (for form submissions, etc.)
export const trackLead = (leadData) =>
  checkFBPresence() &&
  window.fbq('track', 'Lead', {
    content_name: leadData.contentName || 'Lead Generation',
    content_category: leadData.category || 'Form Submission',
    value: leadData.value || 0,
    currency: leadData.currency || 'EUR',
  });

// Track view content event
export const trackViewContent = (contentData) =>
  checkFBPresence() &&
  window.fbq('track', 'ViewContent', {
    content_name: contentData.contentName,
    content_category: contentData.category,
    content_type: contentData.type || 'product',
    value: contentData.value || 0,
    currency: contentData.currency || 'EUR',
  });
